import { GridColDef } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { Button, GKClientDataGrid, Grid2, StatusField } from "components";
import { PlusIcon } from "components/Icons";
import { useState } from "react";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";
import TelegramModal from "./TelegramModal";

const Telegram = () => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const [telegramData, setTelegramData] = useState<any>({});

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["GET_TELEGRAM_BOTS"],
    queryFn: () => axiosInstance.get("/telegram-bots/"),
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Name", "name", 120, 1),
    },
    {
      ...extraColumnsField("First name", "firstName", 120, 1),
    },
    {
      ...extraColumnsField("Id", "telegramId", 120, 1),
    },
    {
      ...extraColumnsField("Status", "isActive", 120, 1),
      renderCell: (params) => (
        <StatusField
          statusString={params?.row?.isActive ? "Active" : "Inactive"}
        />
      ),
    },
    {
      ...extraColumnsField("Bot Token", "botToken", 120, 1),
    },
  ];
  return (
    <>
      <GKClientDataGrid
        loading={isFetching}
        columns={columns}
        rows={data?.data?.data || []}
        showFiltersButton={false}
        headerComponent={
          <Grid2 size={12} display={"flex"} justifyContent={"flex-end"}>
            <Button
              variant="contained"
              startIcon={<PlusIcon />}
              onClick={() => {
                setTelegramData({});
                setOpenModal(true);
              }}
            >
              Create Telegram
            </Button>
          </Grid2>
        }
        onRowClick={(params) => {
          setTelegramData(params.row);
          setOpenModal(true);
        }}
      />

      {openModal && (
        <TelegramModal
          open={openModal}
          setOpen={setOpenModal}
          telegramData={telegramData}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default Telegram;
